import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Api } from "../../services/api";

/**
 * Generated class for the CampaignCashRewardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "campaign-cash-reward/:id",
})
@Component({
  selector: "page-campaign-cash-reward",
  templateUrl: "campaign-cash-reward.html",
})
export class CampaignCashRewardPage {
  items = null;
  totalReward = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private api: Api
  ) {}

  ionViewDidEnter() {
    this.api.myCashReward(this.navParams.data.id).then((data) => {
      this.items = data.items;
      this.totalReward = 0;
      data.items.forEach((item) => {
        this.totalReward += item.amount;
      });
    });
  }

  goback() {
    window.location.hash = "/campaign/" + this.navParams.data.id;
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign-cash-reward/campaign-cash-reward.ts